








































import Vue from "vue";
import DialogWrapper from "@/components/dialog/DialogWrapper.vue";
import AuthService, {
  authServiceInstance as authService,
} from "@/services/AuthService";
import AlertService from "@/services/libs/AlertService";

export default Vue.extend({
  name: "LoginDialog",
  components: { DialogWrapper },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      open: this.value,
      ticket: "",
      error: "",
      isLoading: false,
    };
  },
  watch: {
    value() {
      this.open = this.value;
      this.checkIfAlreadyLoggedIn();
    },
  },
  mounted() {
    this.checkIfAlreadyLoggedIn();
  },
  methods: {
    onLogin() {
      this.error = "";
      if (!this.ticket) this.error = "Bitte zuerst ein Ticket eingeben.";
      else {
        this.isLoading = true;
        authService
          .login(this.ticket)
          // close dialog
          .then(() => {
            // show success message
            AlertService.success("Angemeldet");
            this.$router.push({ path: "/" });
            this.close();
          })
          // catch error
          .catch((err: Error) => (this.error = err.message || err.toString()))
          // close loading state
          .finally(() => (this.isLoading = false));
      }
    },
    checkIfAlreadyLoggedIn() {
      if (this.open && AuthService.isLoggedIn()) {
        AlertService.warning("Zuerst abmelden");
        this.close();
      }
    },
    close() {
      this.error = "";
      this.$emit("input", false);
    },
  },
});
